import { Configuration, findConfiguration } from '@/api'
import { useQuery } from '@tanstack/react-query'

export default ({
  groupId,
  enabled,
  select,
}: {
  groupId?: string
  enabled?: boolean
  select?: ({ data }: { data?: Configuration[] }) => Configuration[]
}) => {
  return useQuery(
    ['findConfigurations'],
    () => findConfiguration({ groupId }),
    {
      enabled: !!enabled,
      select: select ? select : ({ data }) => data,
    }
  )
}
